import React from "react";

export const ContractorDetailContext = React.createContext(null);

export const useContractorDetailContext = () => {
  const context = React.useContext(ContractorDetailContext);

  if (!context) throw new Error("Contractor Detail Context not provided!");

  return context;
};
